import { AlertCircleIcon } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "./alert/Alert";

const UnexpectedBackendError = () => {
  return (
    <Alert variant="destructive">
      <AlertCircleIcon />
      <AlertTitle>Unexpected error while executing your request</AlertTitle>
      <AlertDescription>
        An unexpected error raised while we were fulfilling your request.
      </AlertDescription>
    </Alert>
  );
};

export default UnexpectedBackendError;
